<template>
    <div class="events overflow-y-auto">

        <!-- <vue-datepicker
            :value="day"
            :monday-first="false"
            v-on:selected="setExpandedDay"
            format="dd-MM-yyyy"
            wrapper-class="text-center dark mt-1"
            calendar-class="text-left"
            :required="false"
            v-if="getCurrentView != 'agendaDay'">
        </vue-datepicker> -->


        <!-- Old list view of events on the selected day -->
        <!-- <div v-if="getStoredEvents && getStoredDates[day]" class="list">
            <div v-for="event in sortedEvents">
                <event :event="event"></event>
            </div>
        </div>

        <div v-else>
            <div v-if="!getSelectedEvent" class="p-3 m-2 dark">
                <p>No events found on {{ getExpandedDay }}.</p>
                <p>Maybe try another date?</p>
            </div>
        </div> -->

        <filters></filters>

        <more></more>

    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Event from './Event'
    import Arrow from './Arrow'
    import More from './EventMore'
    import Filters from './Filters'
    import VueDatepicker from 'vuejs-datepicker'

    export default {
        created: function() {
        },
        computed: {
            ...mapGetters([
                'getExpandedDay',
                'getEvents',
                'getSelectedEvent',
                'getCurrentView',
                'getStoredEvents',
                'getStoredDates'
            ]),
            day: function() {
                return this.getExpandedDay;
            },
            // datesMatch: function() {
            //     return moment(this.getExpandedDay).isSame(moment(this.getSelectedEvent.start), 'day');
            // },
            // expandedEvents: function() {
            //     if (this.getEvents !== undefined) {
            //         let vm = this;
            //         let expanded = [];
            //
            //         this.getEvents.forEach(e => {
            //             let start = this.formatDate(e.start);
            //             let end = this.formatDate(e.end);
            //
            //             if (start == vm.day || end == vm.day) {
            //                 expanded.push(e);
            //             }
            //         });
            //
            //         return expanded;
            //     }
            //
            //     return [];
            // },
            sortedEvents: function(){
                let arrayToSort = this.getStoredDates[this.day].events;

                return arrayToSort.sort(function(eventA, eventB) {
                    if(moment(eventA.start).isAfter(eventB.start)){
                        return 1;
                    } else if (moment(eventA.start).isBefore(eventB.start)) {
                        return -1;
                    } else {
                        return 0;
                    }
                })


            }
        },
        methods: {
            ...mapActions([
                'updateSidebar'
            ]),
            setExpandedDay: function(date) {
                var newDate = this.formatDate(date);

                $('#calendar').fullCalendar('gotoDate', newDate);
                this.updateSidebar(newDate);

                // Push new route parameters
                let viewToURL = '';
                switch (this.getCurrentView) {
                    case 'agendaDay':
                        viewToURL = 'day'
                        break;
                    case 'agendaWeek':
                        viewToURL = 'week'
                        break;
                    default:
                    viewToURL = this.getCurrentView;
                }

                this.$router.push({
                    name: 'calendarExpanded',
                    params: {
                        currentView: viewToURL,
                        expandedDay: newDate
                    }
                });

                //$('#calendar').fullCalendar('gotoDate', newDate);
            },
        },
        components: {
            Event,
            Arrow,
            More,
            VueDatepicker,
            Filters
        }
    }
</script>

<style lang="scss">
    @import '../../assets/scss/_variables.scss';

    .events {
        width: 250px;
        border-left: 2px solid $light;
        position: relative;
        overflow: hidden;
        transition: all 200ms ease-in-out;

        &.showingMore{
            width: 320px;
        }

        .vdp-datepicker input {
            text-align: center;
            margin: 0;
            font-size: $font-size-largest;
            background: transparent;
            border: 0;
            padding: 0;
            width: 160px;
            color: $darkest;
            cursor: pointer;
        }

        .list {
            width: 100%;
            position: absolute;
            transition: transform 0.4s;
        }

        .day {
            padding: 1rem;
            border-bottom: 1px solid $light;
            color: $dark;

            > h3 {
                flex-grow: 1;
            }

            > .arrow {
                cursor: pointer;

                [class^="ico-"] {
                    font-size: 0.5rem;
                    margin-left: 0.75rem;
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// Events.vue?40db698b